import { Controller } from "@hotwired/stimulus";
import {Maskito} from '@maskito/core';
import { maskitoPhoneOptionsGenerator } from "@maskito/phone";
import metadata from "libphonenumber-js/min/metadata";

export default class extends Controller {
  connect() {
    const options = maskitoPhoneOptionsGenerator({
      metadata,
      strict: false,
      countryIsoCode: "KG",
    });
    this.cleanup = new Maskito(this.element, options);
  }

  disconnect() {
    if (this.cleanup) this.cleanup.destroy();
  }
}
